module.exports = __webpack_public_path__ + "img/map-SWEDEN-sv.8a52c27b.png";